/* 130R — anúncio único: selo do carro salvo, destaque da linha na tabela e "Ver todos".
   Lê as linhas de snippets/r130-pdp-aplicacoes.liquid (tr[data-r130-aplic-linha]) e o carro salvo em
   localStorage['r130_garage'] ({brand, model, year}), gravado pela garagem e pelo seletor da home.
   avaliar() é puro (tests/test_r130_aplicacoes.js). Spec: docs/superpowers/specs/2026-10-19-anuncio-multiaplicacao-design.md §3. */
(function () {
  'use strict';
  var RECOLHER_ACIMA = 12;

  function norm(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toUpperCase().replace(/\s+/g, ' ').trim();
  }
  function ano(x) { var n = parseInt(x, 10); return isNaN(n) ? null : n; }
  // Chave do motor, cópia fiel de chaveMotor em assets/r130-motor.js (Tema 2): "3.0 V6" → "3.0", "1.6 Turbo" → "1.6T",
  // "Elétrico" → "EV". O seletor e a garagem gravam o rótulo ("3.0 V6"); a tabela tem só a cilindrada ("3.0").
  function chaveMotor(r) {
    var t = String(r == null ? '' : r).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()
      .replace(/(\d)\s*,\s*(\d)/g, '$1.$2').replace(/\s+/g, ' ').trim();
    if (/^(EV\d*|ELETRIC[OA]|100% ELETRICO)$/.test(t)) return 'EV';
    var m = t.match(/(?:^|[^0-9A-Z.])(\d)\.(\d)(?![0-9])\s*(T-?GDI|TURBO|T)?(?![0-9A-Z])/);
    if (!m) return '';
    return m[1] + '.' + m[2] + (m[3] || /\bTURBO\b/.test(t) ? 'T' : '');
  }
  function motorIgual(a) { return chaveMotor(a) || norm(a); }
  function faixa(l) {
    if (l.de != null && l.ate != null) return l.de === l.ate ? 'em ' + l.de : 'de ' + l.de + ' a ' + l.ate;
    if (l.de != null) return l.de + ' em diante';
    if (l.ate != null) return 'até ' + l.ate;
    return '';
  }

  // estado: 'sem-carro' | 'serve' (modelo igual, ano na faixa e, se o carro tem motor, motor igual)
  //         | 'motor' (modelo e ano batem, motor salvo não) | 'ano' (modelo igual, ano fora ou vazio) | 'fora'
  // Sem motor salvo, marca todas as linhas do modelo/ano; `motores` lista os motores delas ("2.4 ou 3.5").
  // Motor compara pela chave (chaveMotor); linha sem motor cadastrado aceita qualquer motor.
  function avaliar(carro, linhas, anoAtual) {
    if (!carro || !carro.model) return { estado: 'sem-carro', indices: [], faixas: '', modelo: '', motores: '' };
    var alvo = norm(carro.model), y = ano(carro.year), querMotor = motorIgual(carro.motor);
    var doModelo = [], noAno = [], faixas = [], motores = [];
    linhas.forEach(function (l, i) {
      if (norm(l.modelo) !== alvo) return;
      doModelo.push(l);
      // "em diante" vai até o ano-modelo do ano que vem (o catálogo de motores já tem 2027 em 2026)
      var de = l.de == null ? -Infinity : l.de, ate = l.ate == null ? anoAtual + 1 : l.ate;
      if (y !== null && y >= de && y <= ate) {
        noAno.push(i);
        if (l.motor && motores.indexOf(l.motor) === -1) motores.push(l.motor);
      }
      var f = faixa(l);
      if (f && faixas.indexOf(f) === -1) faixas.push(f);
    });
    var indices = !querMotor ? noAno : noAno.filter(function (i) {
      return !linhas[i].motor || motorIgual(linhas[i].motor) === querMotor;
    });
    return {
      estado: indices.length ? 'serve' : (noAno.length ? 'motor' : (doModelo.length ? 'ano' : 'fora')),
      indices: indices,
      faixas: faixas.join(' e '),
      modelo: doModelo.length ? doModelo[0].modelo : '',
      motores: motores.join(' ou ')
    };
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) { return '&#' + ch.charCodeAt(0) + ';'; });
  }
  function cap(s) {
    return String(s || '').split(' ').map(function (w) {
      if (/\d/.test(w) || ['BMW', 'VW', 'GM'].indexOf(w.toUpperCase()) !== -1) return w.toUpperCase();
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }
  function carroSalvo() {
    try { var c = JSON.parse(localStorage.getItem('r130_garage')); return c && c.model ? c : null; } catch (e) { return null; }
  }

  // Regra do site (Tema 2): nunca dizer "serve". Quando o carro salvo bate com a tabela: "Aplicação confirmada"
  // (Marcus, 20/10/2026); nos outros casos, "aplicação cadastrada" e "confirme pelo chassi"
  // (snippets/r130-carro-convite.liquid, 130r-garagem-virtual.liquid).
  function textoSelo(r, carro) {
    var modelo = esc(r.modelo), seu = modelo + ' ' + esc(ano(carro.year));
    if (r.estado === 'serve') {
      if (carro.motor) {
        return '<strong>Aplicação confirmada</strong> para o seu ' + seu + ' ' + esc(carro.motor) + '. Na dúvida, confirme pelo chassi.';
      }
      if (r.motores.indexOf(' ou ') !== -1) {
        return '<strong>Aplicação confirmada</strong> para o seu ' + seu + ' com motor ' + esc(r.motores) +
          '. Confirme o motor do seu carro antes de comprar; na dúvida, mande o chassi.';
      }
      return '<strong>Aplicação confirmada</strong> para o seu ' + seu + (r.motores ? ' (motor ' + esc(r.motores) + ')' : '') +
        '. Na dúvida sobre o motor, confirme pelo chassi.';
    }
    if (r.estado === 'motor') {
      return '<strong>Confira o motor:</strong> para o seu ' + seu + ', a aplicação cadastrada é com motor ' + esc(r.motores) + '.';
    }
    if (r.estado === 'ano') {
      return r.faixas
        ? '<strong>Confira o ano:</strong> aplicação cadastrada para ' + modelo + ' ' + esc(r.faixas) + '.'
        : '<strong>Confira o ano</strong> e o motor pelo chassi: aplicação cadastrada sem ano para ' + modelo + '.';
    }
    return '<strong>Seu carro salvo é ' + esc(cap(carro.brand)) + ' ' + esc(cap(carro.model)) +
      '.</strong> Esta peça não se aplica neste modelo; confira a peça indicada.';
  }

  var CLASSE_SELO = { serve: 'match', motor: 'check', ano: 'check', fora: 'no-match' };

  function atualizar() {
    var trs = Array.prototype.slice.call(document.querySelectorAll('[data-r130-aplic-linha]'));
    if (!trs.length) return;
    var linhas = trs.map(function (tr) {
      return { modelo: tr.getAttribute('data-modelo'), motor: tr.getAttribute('data-motor') || null,
        de: ano(tr.getAttribute('data-de')), ate: ano(tr.getAttribute('data-ate')) };
    });
    var carro = carroSalvo();
    var r = avaliar(carro, linhas, new Date().getFullYear());

    trs.forEach(function (tr, i) {
      var seu = r.indices.indexOf(i) !== -1;
      tr.classList.toggle('is-seu-carro', seu);
      var antiga = tr.querySelector('.r130-aplic__seu');
      if (antiga) antiga.parentNode.removeChild(antiga);
      if (seu) {
        var tag = document.createElement('span');
        tag.className = 'r130-aplic__seu';
        tag.textContent = 'Seu carro';
        tr.querySelector('th').appendChild(tag);
      }
    });

    document.querySelectorAll('[data-r130-aplic-selo]').forEach(function (selo) {
      if (r.estado === 'sem-carro') { selo.hidden = true; return; }
      selo.className = 'r130-fitment-badge ' + CLASSE_SELO[r.estado];
      selo.innerHTML = textoSelo(r, carro);
      selo.hidden = false;
    });
    // peça que não se aplica ao carro salvo (outro modelo ou outro ano): botão para a peça indicada
    // (window.r130PecaIndicada, snippets/130r-garagem-virtual.liquid); sem peça indicada, o texto volta a pedir o chassi
    if (window.r130PecaIndicada) {
      var errada = r.estado === 'fora' || r.estado === 'ano';
      window.r130PecaIndicada(errada ? carro : null, function () {
        if (r.estado !== 'fora') return;
        document.querySelectorAll('[data-r130-aplic-selo]').forEach(function (selo) {
          selo.innerHTML = selo.innerHTML.replace('confira a peça indicada.', 'confirme pelo chassi antes de comprar.');
        });
      });
    }
  }

  function recolher() {
    var secao = document.querySelector('[data-r130-aplic]');
    var botao = document.querySelector('[data-r130-aplic-mais]');
    if (!secao || !botao || document.querySelectorAll('[data-r130-aplic-linha]').length <= RECOLHER_ACIMA) return;
    secao.classList.add('r130-aplic--recolhido');
    botao.hidden = false;
    botao.addEventListener('click', function () {
      secao.classList.remove('r130-aplic--recolhido');
      botao.hidden = true;
    });
  }

  function iniciar() {
    if (!document.querySelector('[data-r130-aplic-linha]')) return;
    recolher();
    ['r130-btn-save-garage', 'r130-btn-clear-garage'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', function () { setTimeout(atualizar, 0); });
    });
    window.addEventListener('storage', function (e) { if (e.key === 'r130_garage') atualizar(); });
    atualizar();
  }

  window.r130Aplic = { norm: norm, chaveMotor: chaveMotor, avaliar: avaliar, texto: textoSelo };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
